import main from "./links.svg"
import addNew from "./add_new.svg"

const usefulLinks = { main, addNew }

export default usefulLinks
